import React, { useState, useCallback } from 'react';
import { useNavigate } from 'react-router';
import { FeatureExtractionAPI } from '../../api/client';
import FeatureExtractionJobForm, { DEFAULT_QUALITY_THRESHOLD } from '../../components/Forms/FeatureExtraction/FeatureExtractionJobForm';

const NewFeatureExtractionJobPage = () => {
  const [formData, setFormData] = useState({
    slug: '',
    name: '',
    description: '',
    quality_threshold: DEFAULT_QUALITY_THRESHOLD
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const onSubmit = useCallback(async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const payload = {
        query: {
          data_source: `data/${formData.slug}/`,
          demographics_file_name: 'demographics.csv',
        },
        name: formData.name,
        description: formData.description,
        slug: formData.slug,
        quality_threshold: formData.quality_threshold,
      };
      const job = await FeatureExtractionAPI.create(payload);
      navigate(`/feature-extraction/${job.id}`);
    } catch (e) {
      setError('Failed to create feature extraction job');
    } finally {
      setLoading(false);
    }
  }, [formData, navigate]);

  return (
    <FeatureExtractionJobForm
      formData={formData}
      setFormData={setFormData}
      isEditing={true}
      title="Feature Extraction > New"
      onSubmit={onSubmit}
      submitText="Create Job"
      submitLoading={loading}
      error={error}
    />
  );
};

export default NewFeatureExtractionJobPage;
